/**
 * Detects failed dynamic imports after a deploy (stale entry JS still
 * references hashed chunks that no longer exist). Browsers surface this as
 * a few different TypeError messages; we treat them the same: recover by
 * hard-reloading onto a fresh shell.
 */
export const isChunkLoadError = (error: unknown): boolean => {
  const msg = error instanceof Error ? error.message : String(error ?? '');
  if (!msg) return false;

  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg) ||
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Loading CSS chunk [\w-]+ failed/i.test(msg) ||
    // Chromium sometimes wraps the URL into the message without the
    // "Failed to fetch" prefix when the response was HTML (SPA catchall).
    /dynamically imported module/i.test(msg)
  );
};
